// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import Checkbox from '../../Checkbox/Checkbox';

import style from '../Filter.scss';
import icons from '../../../assets/styles/icons.scss';

import type { FilterCheckboxType, FilterCheckbox } from '../Filter';

type Props = {
  +filterField: FilterCheckboxType;
};

export default class CheckBoxType extends Component<Props> {
  render() {
    const { filterField } = this.props;
    const content = filterField.checkboxes && filterField.checkboxes.map((checkbox: FilterCheckbox, n: number) => (
      <li key={n}>
        {checkbox.label &&
        <Checkbox handleChange={filterField.handler}
                  name={filterField.name}
                  value={checkbox.value}
                  color={filterField.color || 'lightBlue'}
                  isChecked={filterField.stateValue ?
                    filterField.stateValue[checkbox.value] : false}>
          {checkbox.label}
        </Checkbox>}
        {checkbox.labelIntl &&
        <Checkbox handleChange={filterField.handler}
                  name={filterField.name}
                  value={checkbox.value}
                  color={filterField.color || 'lightBlue'}
                  isChecked={filterField.stateValue ?
                    filterField.stateValue[checkbox.value] : false}>
          {this.context.intl.formatMessage({ id: checkbox.labelIntl })}
        </Checkbox>}
      </li>
    ));
    return (
      <article className={classNames(style.filterFieldWrap)}>
        <FormattedMessage id={filterField.titleIntl}>{
          txt => <h2 className={classNames(style.filterTitle, { [style.open]: filterField.isOpen })}
                     onClick={filterField.handleOpen}>{txt}
            <i className={classNames(style.caret,
              { [icons.iconMinusLight]: filterField.isOpen },
              { [icons.iconPlusLight]: !filterField.isOpen })}/>
          </h2>
        }</FormattedMessage>
        {filterField.isOpen &&
        <ul className={style.checkbox}>
          {content}
        </ul>}
      </article>
    );
  }
}

CheckBoxType.propTypes = {
  filterField: PropTypes.object.isRequired,
};

CheckBoxType.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/CheckboxType/CheckboxType.jsx